import React from 'react'
import { X } from 'lucide-react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'
import { useAppWeb3 } from '@/hooks'
import { Token } from '@/sdk'
import { useRemoveUserAddedToken } from '@/state/user/hooks'

/** Quita un token importado de la lista del usuario. */
export function ImportedTokenRemoveButton({
  token,
  className,
  onRemoved,
}: {
  token: Token
  className?: string
  onRemoved?: () => void
}) {
  const { chainId } = useAppWeb3()
  const removeToken = useRemoveUserAddedToken()

  if (chainId == null) return null

  return (
    <button
      type="button"
      className={cn('nm-mobile-simple__picker-remove-btn', className)}
      aria-label={nutrimaticLabels.mobileSimple.pickerRemoveImported}
      onClick={(event) => {
        event.stopPropagation()
        removeToken(chainId, token.address)
        onRemoved?.()
      }}
    >
      <X className="size-4" aria-hidden />
    </button>
  )
}
